module.exports = __webpack_public_path__ + "img/header_bg_big.3b58bfcd.png";